// packages/web/src/components/marketplace/AddressWarningDialog.tsx
// Address warning dialog component

import { Warning as WarningIcon } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';
import React from 'react';

interface AddressWarningDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  serviceName?: string;
}

const AddressWarningDialog: React.FC<AddressWarningDialogProps> = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  serviceName
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon color="warning" />
        Service Unavailable at New Address
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          The service "{serviceName}" is not available at your selected address.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This service has geographic restrictions that limit where it can be provided.
          Would you like to return to the marketplace to find alternative services, or keep your current address selection?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          color="inherit"
        >
          Keep Current Address
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
        >
          Return to Marketplace
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(AddressWarningDialog);